import { isManifestUrl } from '../../common/utils/sourceTypeUtils';

export default function isAllowedManifestUrl(
  app: string,
  url: string
): boolean {
  switch (app) {
    case 'kaltura.eventplatform':
    case 'kaltura.mediaspace':
      return !isManifestUrl(url);
    default:
      return true;
  }
}
